import { render, staticRenderFns } from "./message-center.vue?vue&type=template&id=74d4bd52&scoped=true&"
import script from "./message-center.vue?vue&type=script&lang=js&"
export * from "./message-center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d4bd52",
  null
  
)

export default component.exports